import type { Locale } from '../translations';

export function guideText(locale: Locale, en: string, ptBr: string): string {
    return locale === 'pt-BR' ? ptBr || en : en || ptBr;
}

export function slugify(value: string): string {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 120);
}
